import React, { createContext, useCallback, useContext, useState } from "react";
import QuoteModal from "@/components/QuoteModal";

const Ctx = createContext(null);

export function QuoteProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [prefill, setPrefill] = useState({});
  const openQuote = useCallback((initial = {}) => {
    setPrefill(initial);
    setOpen(true);
  }, []);
  return (
    <Ctx.Provider value={{ openQuote }}>
      {children}
      <QuoteModal open={open} onOpenChange={setOpen} prefill={prefill} />
    </Ctx.Provider>
  );
}

export function useQuote() {
  return useContext(Ctx);
}
